import { Component, OnInit, ViewChild } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { Product } from '@app/forms/subscription/definition/interface/Pledge';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';

import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'scpi-divident',
    templateUrl: './scpi-divident.component.html',
    styleUrls: ['./scpi-divident.component.scss'],
    standalone: false
})
export class ScpiDividentComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  @ViewChild('linearVerticalStepper', { static: true })
  private steper: MatStepper;
  products: Product[] = [];
  currentPageNumber: number = 0;
  itemsPerPage: number = 1;
  productIds: number[] = [];
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    const pledge = this.subscriptionFacade.getPledge();

    const { products = [] } = pledge || {};

    const productIds = products
      .filter(
        ({ parameters }) => !!parameters.scpiEnableReinvestissementDividendes,
      )
      .map(({ productId }) => productId);

    const matchingProducts = this.getMatchingProducts(productIds, products);
    this.products = matchingProducts || [];
    this.productIds =
      matchingProducts?.map(product => product?.productId) || [];

    this.initForm(pledge?.products || []);
  }

  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.selectErrorInputAndScroll(this);
    this.extract();

    if (
      this.scpis.controls[this.currentPageNumber]?.valid &&
      this.currentPageNumber == this.products.length - 1
    )
      this.subscriptionFacade.submitPledge(this, 'products');
    if (
      this.scpis.controls[this.currentPageNumber]?.valid &&
      this.currentPageNumber < this.products.length - 1
    ) {
      this.subscriptionFacade.submitPledge(
        this,
        'products',
        false,
        this.nextStep.bind(this),
        true,
      );
    }
  }
  prev() {
    if (this.currentPageNumber == 0) {
      this.subscriptionFacade.previousStep();
    }
    if (this.currentPageNumber > 0) this.currentPageNumber--;
    this.steper.previous();
  }
  nextPage() {
    this.currentPageNumber++;
  }

  nextStep() {
    this.currentPageNumber++;
    this.steper.next();
    this.steper.selected.completed = true;
  }
  prevStep() {
    if (this.currentPageNumber == 0) {
      this.subscriptionFacade.previousStep();
      this.steper.previous();
    }
    if (this.currentPageNumber > 0) this.currentPageNumber--;
  }
  stepClick(ev) {
    this.currentPageNumber = ev.selectedIndex;
  }
  getMatchingProducts(
    questionIds: number[],
    productList: Product[],
  ): Product[] {
    return productList.filter(product =>
      questionIds?.includes(product?.productId),
    );
  }
}
